module.exports = __webpack_public_path__ + "img/gis1.8c2a2cc2.png";